// **Third Party Imports
import axios from 'axios'

// **Utils Imports
import { API_URL } from '../env/env'
import { getJWTToken, logoutUser } from '../utils/utils'
import { ERROR_500 } from '../utils/constant'

axios.defaults.baseURL = API_URL

axios.interceptors.request.use(
  (config) => {
    const accessToken = getJWTToken()

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => ({
    isError: true,
    status: error?.response?.status || 500,
    message:
      error?.response?.data ||
      (!window?.navigator?.onLine ? 'You are offline' : ERROR_500)
  })
)

axios.interceptors.response.use(
  (response) => response?.data,
  (error) => {
    if (error.response && error.response.status === 403) {
      logoutUser()
    }

    return {
      isError: true,
      status: error?.response?.status || 500,
      message:
        error?.response?.data ||
        (!window?.navigator?.onLine ? 'You are offline' : ERROR_500)
    }
  }
)

export default axios
